import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

  import {PersistGate} from "redux-persist/integration/react";
import {persistStore} from "redux-persist";
import store from './Redux/Store';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
const persistor = persistStore(store);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//NOTE Create Custom Theme
const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "Peyda",
  },
  
});

//NOTE Create RTL Cache
const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <CacheProvider value={cacheRTL}>
        <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
        <App />
        </HelmetProvider>
          </PersistGate>
          <ToastContainer />
        </ThemeProvider>
      </CacheProvider>
    </BrowserRouter>
    </Provider>
  </React.StrictMode>
);


